import { Typography, styled, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import NavbarCell from './NavbarCell';
import createPermissionCheckers from '../../permissions-validation/createPermissionCheckers';

const StyledTypography = styled(Typography)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'left',
  paddingTop: '12px',
  paddingLeft: '28px',
}));

export interface IManagementDataProps {
  id: number;
  title: string;
  url: string;
  src: string;
  boldIcon: string;
  permissions?: string[] | string;
  subtitle?: string;
  main?: string;
}

interface IManagementSectionProps {
  managementName?: string;
  managementData: IManagementDataProps[];
  setHidden: React.Dispatch<React.SetStateAction<boolean>>;
}

function ManagementSection({ managementName, managementData, setHidden }: IManagementSectionProps) {
  const { t } = useTranslation();
  const location = useLocation();
  const permissionCheckers = createPermissionCheckers();
  const { checkPermissions } = permissionCheckers;

  return (
    <Box sx={{ backgroundColor: '#ffff' }}>
      {managementName && (
        <Box sx={{ backgroundColor: '#ffff' }}>
          <StyledTypography
            variant="meta"
            color="primary"
            fontWeight={700}
            px={1}
            textTransform="capitalize"
            sx={{ backgroundColor: '#ffff' }}
          >
            {t(managementName)}
          </StyledTypography>
          <Box
            sx={{
              backgroundColor: '#ffff',
              pt: '12px',
              opacity: 0.5,
            }}
          />
        </Box>
      )}
      {managementData.map(
        (item) =>
          checkPermissions(item.permissions, true) && (
            <Box
              key={item.id}
              pr="2px"
              pl="2px"
              display="block"
              justifyContent="left"
              sx={{ backgroundColor: '#ffff' }}
            >
              <NavbarCell
                title={item.title}
                url={item.url}
                src={item.src}
                boldIcon={item.boldIcon}
                isSelected={location.pathname.split('/')[1] === item.url.split('/')[1]}
                subtitle={item.subtitle}
                setHidden={setHidden}
              />
            </Box>
          )
      )}
    </Box>
  );
}

export default ManagementSection;
